import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function PromoBanners() {
  return <section className="py-8" aria-label="Promotional banners" data-id="element-233" data-mp="76ed2b8yael8">
      <div className="max-w-7xl mx-auto px-4" data-id="element-234" data-mp="l7h1uvrby2zu">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-235" data-mp="l65xatq28r7o">
          {/* Banner 1 */}
          <Link to="/products?category=earbuds" className="relative overflow-hidden rounded-xl bg-gradient-to-r from-purple-600 to-purple-800 p-6 h-48 flex flex-col justify-end group" data-id="element-236" data-mp="g5ro38cq3b82">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-237" data-mp="3jq5un6c63axz" />
            <div className="relative z-10" data-id="element-238" data-mp="29wbfk8x2wd4">
              <p className="text-purple-200 text-sm mb-1" data-id="element-239" data-mp="3tmh5drw3zsqb">Up to 50% Off</p>
              <h3 className="text-white text-xl font-bold mb-2" data-id="element-240" data-mp="35wwmta3vaxhk">
                Wireless Earbuds
              </h3>
              <span className="inline-flex items-center gap-1 text-white text-sm font-medium group-hover:gap-2 transition-all" data-id="element-241" data-mp="30yv5atm3b687">
                Shop Now <ArrowRightIcon className="w-4 h-4" data-id="element-242" data-mp="3twtsnpnj6ps5" />
              </span>
            </div>
          </Link>

          {/* Banner 2 */}
          <Link to="/products?category=smart-watches" className="relative overflow-hidden rounded-xl bg-gradient-to-r from-blue-600 to-blue-800 p-6 h-48 flex flex-col justify-end group" data-id="element-243" data-mp="7hqx4egqcq8p">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-244" data-mp="bl6rf45buei8" />
            <div className="relative z-10" data-id="element-245" data-mp="3fxalp06ghkhf">
              <p className="text-blue-200 text-sm mb-1" data-id="element-246" data-mp="3fy3x4egd0y5w">New Collection</p>
              <h3 className="text-white text-xl font-bold mb-2" data-id="element-247" data-mp="3jyw574dhwx0l">
                Smart Watches
              </h3>
              <span className="inline-flex items-center gap-1 text-white text-sm font-medium group-hover:gap-2 transition-all" data-id="element-248" data-mp="3oz1tcakk41dx">
                Explore <ArrowRightIcon className="w-4 h-4" data-id="element-249" data-mp="zbavtdqcaiaa" />
              </span>
            </div>
          </Link>

          {/* Banner 3 */}
          <Link to="/products?category=gaming-accessories" className="relative overflow-hidden rounded-xl bg-gradient-to-r from-green-600 to-green-800 p-6 h-48 flex flex-col justify-end group md:col-span-2 lg:col-span-1" data-id="element-250" data-mp="30ams0iu4040o">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-251" data-mp="3a80z3ru57ggb" />
            <div className="relative z-10" data-id="element-252" data-mp="35b24l86kh7hl">
              <p className="text-green-200 text-sm mb-1" data-id="element-253" data-mp="2hk54qts1q0mp">Gamers Choice</p>
              <h3 className="text-white text-xl font-bold mb-2" data-id="element-254" data-mp="2hibuz5m4z0ah">Gaming Gear</h3>
              <span className="inline-flex items-center gap-1 text-white text-sm font-medium group-hover:gap-2 transition-all" data-id="element-255" data-mp="2cnep27k5l71t">
                Level Up <ArrowRightIcon className="w-4 h-4" data-id="element-256" data-mp="2mk17kpp0bm0o" />
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>;
}